import styled from 'styled-components';

export const RefreshDiv = styled.button`
  display: none;
  float: right;
  margin-bottom: 10px;
  padding: 4px 5px 3px;
  border-radius: 6px;

  img {
    display: block;
    width: 25px;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.12);
  }

  @media (max-width: 1024px), (pointer: coarse) {
    display: block;
  }

  ${({ table }) =>
    table
      ? `& {
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 10;
  }`
      : ''};
`;
